import { render, staticRenderFns } from "./BaseButtonDownload.vue?vue&type=template&id=1cacd08a&scoped=true&"
import script from "./BaseButtonDownload.vue?vue&type=script&lang=js&"
export * from "./BaseButtonDownload.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonDownload.vue?vue&type=style&index=0&id=1cacd08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cacd08a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cacd08a')) {
      api.createRecord('1cacd08a', component.options)
    } else {
      api.reload('1cacd08a', component.options)
    }
    module.hot.accept("./BaseButtonDownload.vue?vue&type=template&id=1cacd08a&scoped=true&", function () {
      api.rerender('1cacd08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseButtonDownload.vue"
export default component.exports